import { z } from "zod"

import type { Company } from "@/graphql/codegen/graphql"

export const siblingCompaniesFormSchema = z.object({
  companies: z.array(z.custom<Company>()),
})

export type SiblingCompaniesFormValues = z.infer<typeof siblingCompaniesFormSchema>
